import HotelIcon from "@mui/icons-material/Hotel";
import { ACCOMMODATIONS, DormitoryServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListAccommodations from "./List";

export const resources = {
  isMenu: true,
  icon: <HotelIcon />,
  name: DormitoryServicePath + ACCOMMODATIONS,
  exactMenuMatch: true,
  title: "Настанявания",
  list: <ListAccommodations />,
  permission: permissions.canPreviewDormitoryCampaigns,
};
